class SaveUser {
    public user: unknown = null

    public password: string | null = null
}

export default new SaveUser()
